import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormCreatorService, TypeChecker } from 'lib-base';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { Subscription } from 'rxjs';
import { KeyFilterModule } from 'primeng/keyfilter';

@Component({
  selector: 'app-page-options',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, TranslateModule, KeyFilterModule,
    AccordionModule, InputTextModule, ButtonModule, DropdownModule, CheckboxModule, MultiSelectModule
  ],
  templateUrl: './page-options.component.html',
  styleUrl: './page-options.component.scss'
})
export class PageOptionsComponent {

  typeChecker = TypeChecker;
  readonly MAX_TITLE_LENGTH = 250;
  private _updateSubscription !: Subscription | undefined;
  private _subscriptionShowConfiguration !: Subscription;
  formGroup !: FormGroup;

  constructor(public fc: FormCreatorService, private _fb: FormBuilder) {
    this.initialize();
  }

  ngOnInit(): void {
    this._subscriptionShowConfiguration = this.fc.showConfigurationEvent.subscribe(() => {
      this.initialize();
    });
  }

  ngOnDestroy(): void {
    if (this._updateSubscription) {
      this._updateSubscription.unsubscribe();
    }
    this._subscriptionShowConfiguration.unsubscribe();
  }

  //#region Getters
  get Type() {
    return this.fc.ConfigurationSection.type;
  }

  get Page() {
    return this.fc.ConfigurationSection.page;
  }
  //#endregion Getters

  initialize() {
    this.setPageFormGroup();
    this.setPageUpdateSubscription();
  }

  private setPageFormGroup() {
    this.formGroup = this._fb.group({
      general: this._fb.group({
        name: [this.Page?.name, { validators: [Validators.required, Validators.maxLength(this.MAX_TITLE_LENGTH), this.uniquePageNameValidator()] }],
        label: [this.Page?.title, { validators: [Validators.required, Validators.maxLength(this.MAX_TITLE_LENGTH)] }],
        hideTitle: [this.Page?.hideTitle],
      }),
    });
  }

  private setPageUpdateSubscription() {
    this._updateSubscription = this.formGroup.get('general')?.valueChanges.subscribe((value) => {
      if (!this.fc.ConfigurationSection.page) return;
      if (this.formGroup.get('general')?.invalid) return;
      this.fc.Form.updatePageProperties(this.fc.ConfigurationSection.page, value)
    });
  }

  //#region Validators
  uniquePageNameValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!this.Page) return null;
      const isUniqueName = this.fc.validateUniquePageName(this.Page?.name, control.value);
      if (isUniqueName)
        return null;
      return { uniqueName: true };
    }
  }
  //#endregion Validators
}
